'use strict';
const angular = require('angular');

export default angular.module('appApp.selecthousingpolicies', [])
  .directive('selecthousingpolicies', function() {
    return {
      template: require('./selecthousingpolicies.html'),
      restrict: 'EA',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/selecthousingpolicies/selecthousingpolicies.directive.js